import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import axios from 'axios';
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Input,
  Button,
  FormGroup,
  Label,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import apiConfig from "../config/apiConfig";

function Email() {
  const serverUrl = apiConfig.serverUrl;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [users, setUsers] = useState([]);
  const [filters, setFilters] = useState({
    search: '',
    specialFilter: '',
    userType: '', // 1: نوع کاربر (مشاوره - رژیم)
    dietType: '', // 2: نوع رژیم (کاهش- افزایش- ثبات)
    expiredDuration: '', // 3: مدت زمانی که دوره اش تمام شده (مثلا '30' برای 30 روز گذشته)
    purchaseCount: '', // 4: تعداد دوره ای که تا حالا خریده (مثلا min)
    weightLossPercent: '', // 5: درصد وزنی که تا حالا کم کرده (مثلا '>=10')
    weightGainPercent: '', // 6: درصد وزنی که تا حالا اضافه کرده (مثلا '>=10')
    weightStability: '', // 7: ثابت بودن در وزن (مثلا 'stable' برای نوسان کم)
    bmi: '', // 8: بر اساس bmi (مثلا 'over30', 'under18', etc.)
    bmiMin: '', // حداقل BMI برای رنج دستی
    bmiMax: '', // حداکثر BMI برای رنج دستی
    gender: '', // 9: جنسیت
    age: '', // 10: بر اساس سن (مثلا '18-30', 'over50', etc.)
    ageMin: '', // حداقل سن برای رنج دستی
    ageMax: '' // حداکثر سن برای رنج دستی
  });
  const [modalOpen, setModalOpen] = useState(false);
  const [emailContent, setEmailContent] = useState('');
  const [emailSubject, setEmailSubject] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [customContent, setCustomContent] = useState('');
  const [selectedTemplate, setSelectedTemplate] = useState('default');

  // دریافت اطلاعات کاربران از سرور
  useEffect(() => {
    setLoading(true);
    axios.get(serverUrl + "get-user-email")
      .then((response) => {
        setUsers(response.data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
        toast.error('خطا در دریافت اطلاعات کاربران');
      });
  }, []);

  // به‌روزرسانی محتوای ادیتور هنگام تغییر تمپلیت
  useEffect(() => {
    if (selectedTemplate) {
      const template = emailTemplates[selectedTemplate];
      setCustomContent(template.content); // حفظ USER_NAME در ادیتور
      updateEmailContent(template.content, template.class, template.buttonText, template.buttonLink);
    }
  }, [selectedTemplate, selectedUser]);
  // گزینه‌های نوع فیلتر تعداد دوره‌ها
  const purchaseCountFilterTypeOptions = [
    { value: 'exact', label: 'دقیق' },
    { value: 'minimum', label: 'حداقل' }
  ];
    // افزودن حالت انتخاب برای نوع فیلتر تعداد دوره‌ها
    const [purchaseCountFilterType, setPurchaseCountFilterType] = useState('exact'); // 'exact' یا 


  // فیلتر کردن کاربران
  const filteredUsers = users.filter(user => {
    const searchFilter = filters.search === '' || 
      (user.name && typeof user.name === 'string' && user.name.includes(filters.search)) || 
      (user.email && typeof user.email === 'string' && user.email.includes(filters.search));
    
      let specialFilter = true;
      if (filters.specialFilter === 'diet-user') {
        specialFilter = user.userType === 'رژیم';
      } else if (filters.specialFilter === 'consultation-user') {
        specialFilter = user.userType === 'مشاوره';
      }

    // فیلترهای جدید (فرض بر این است که فیلدهای مربوطه در user وجود خواهند داشت پس از تنظیم بک‌اند)
    let userTypeFilter = true;
    if (filters.userType) {
      userTypeFilter = user.userType === filters.userType; // مثلا 'مشاوره' یا 'رژیم'
    }

    let dietTypeFilter = true;
    if (filters.dietType) {
      dietTypeFilter = user.dietType === filters.dietType; // مثلا 'کاهش', 'افزایش', 'ثبات'
    }

    let expiredDurationFilter = true;
    if (filters.expiredDuration) {
      // مثلا اگر expiredDuration یک عدد روز باشد، چک کنیم user.expiredDays >= parseInt(filters.expiredDuration)
      expiredDurationFilter = user.expiredDays >= parseInt(filters.expiredDuration);
    }

    let purchaseCountFilter = true;
    if (filters.purchaseCount) {
      const purchaseCountValue = parseInt(filters.purchaseCount);
      if (purchaseCountFilterType === 'exact') {
        purchaseCountFilter = user.purchaseCount === purchaseCountValue; // فیلتر دقیق
      } else if (purchaseCountFilterType === 'minimum') {
        purchaseCountFilter = user.purchaseCount >= purchaseCountValue; // فیلتر حداقل
      }
    }
    let weightLossPercentFilter = true;
    if (filters.weightLossPercent) {
      weightLossPercentFilter = user.weightLossPercent >= parseFloat(filters.weightLossPercent);
    }

    let weightGainPercentFilter = true;
    if (filters.weightGainPercent) {
      weightGainPercentFilter = user.weightGainPercent >= parseFloat(filters.weightGainPercent);
    }

    let weightStabilityFilter = true;
    if (filters.weightStability === 'stable') {
      weightStabilityFilter = user.weightStability === true; // یا شرط نوسان کم، مثلا user.weightFluctuation <= 1
    }

    let bmiFilter = true;
    if (filters.bmi) {
      const bmiValue = parseFloat(user.bmi);
      if (filters.bmi === 'custom') {
        const bmiMin = parseFloat(filters.bmiMin) || 0;
        const bmiMax = parseFloat(filters.bmiMax) || Infinity;
        bmiFilter = bmiValue >= bmiMin && bmiValue <= bmiMax;
      } else if (filters.bmi === 'A') {
        bmiFilter = bmiValue < 15.99;
      } else if (filters.bmi === 'B') {
        bmiFilter = bmiValue >= 16 && bmiValue <= 16.99;
      } else if (filters.bmi === 'C') {
        bmiFilter = bmiValue >= 17 && bmiValue <= 18.499;
      } else if (filters.bmi === 'D') {
        bmiFilter = bmiValue >= 18.5 && bmiValue <= 24.99;
      } else if (filters.bmi === 'E') {
        bmiFilter = bmiValue >= 25 && bmiValue <= 29.99;
      } else if (filters.bmi === 'F') {
        bmiFilter = bmiValue >= 30 && bmiValue <= 34.99;
      } else if (filters.bmi === 'G') {
        bmiFilter = bmiValue >= 35 && bmiValue <= 39.99;
      } else if (filters.bmi === 'H') {
        bmiFilter = bmiValue > 39.99;
      }
    }

    let genderFilter = true;
    if (filters.gender) {
      genderFilter = user.gender === filters.gender; // 'مرد' یا 'زن'
    }

    let ageFilter = true;
    if (filters.age) {
      const ageValue = parseFloat(user.age);
      if (filters.age === 'custom') {
        const ageMin = parseFloat(filters.ageMin) || 0;
        const ageMax = parseFloat(filters.ageMax) || Infinity;
        ageFilter = ageValue >= ageMin && ageValue <= ageMax;
      } else if (filters.age === 'under18') {
        ageFilter = ageValue < 18;
      } else if (filters.age === '18-30') {
        ageFilter = ageValue >= 18 && ageValue <= 30;
      } else if (filters.age === '30-50') {
        ageFilter = ageValue >= 30 && ageValue <= 50;
      } else if (filters.age === 'over50') {
        ageFilter = ageValue > 50;
      }
    }

 

    return searchFilter && specialFilter && userTypeFilter && dietTypeFilter && expiredDurationFilter &&
    purchaseCountFilter && weightLossPercentFilter && weightGainPercentFilter && weightStabilityFilter &&
    bmiFilter && genderFilter && ageFilter;
  });


  // استایل‌های ایمیل برای پیش‌نمایش
  const emailStyles = `
    @import url('https://fonts.googleapis.com/css2?family=Dana:wght@400;700&display=swap');
    .email-container {
      font-family: 'Dana', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      max-width: 650px;
      margin: 30px auto;
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
      overflow: hidden;
      direction: rtl;
      text-align: right;
    }
    .email-header {
      padding: 30px;
      color: white;
      text-align: center;
      background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%);
    }
    .email-header h1 {
      margin: 0;
      font-size: 28px;
      font-weight: 700;
    }
    .email-body {
      padding: 30px;
      background: #f8fafc;
    }
    .email-content {
      font-size: 16px;
      line-height: 1.8;
      color: #2d3748;
    }
    .email-content p {
      margin: 10px 0;
    }
    .email-button {
      margin: 25px 0;
      text-align: center;
    }
    .email-button a {
      display: inline-block;
      padding: 12px 30px;
      color: white;
      text-decoration: none;
      border-radius: 25px;
      font-size: 16px;
      font-weight: 600;
      transition: transform 0.2s, box-shadow 0.2s;
    }
    .email-button a:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
    .email-footer {
      background: #edf2f7;
      padding: 20px;
      text-align: center;
      font-size: 14px;
      color: #718096;
    }
    .email-footer a {
      color: #4a90e2;
      text-decoration: none;
      margin: 0 5px;
    }
    .email-footer a:hover {
      text-decoration: underline;
    }
    .preview-container .email-header,
    .preview-container .email-content,
    .preview-container .email-content p,
    .preview-container .email-content h3,
    .preview-container .email-content div,
    .preview-container .email-content span {
      color: #2d3748 !important;
    }
    .birthday-template .email-header {
      background: linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%);
    }
    .birthday-template .email-content {
      background: #fff5f5;
      padding: 20px;
      border-radius: 8px;
      border: 2px dashed #feb2b2;
    }
    .birthday-template .email-button a {
      background: #ff6b6b;
    }
    .welcome-template .email-header {
      background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
    }
    .welcome-template .email-content {
      background: linear-gradient(145deg, #f0fff4, #e6fffa);
      padding: 20px;
      border-radius: 8px;
    }
    .welcome-template .email-button a {
      background: #48bb78;
    }
    .discount-template .email-header {
      background: linear-gradient(135deg, #f6e05e 0%, #ecc94b 100%);
    }
    .discount-template .email-content {
      background: #fefcbf;
      padding: 20px;
      border-radius: 8px;
      border-left: 4px solid #d69e2e;
    }
    .discount-template .email-content h3,
    .discount-template .email-content p:not(.ql-align-center) {
      color: #b7791f;
    }
    .discount-template .email-content p.ql-align-center {
      color: #b7791f;
    }
    .discount-template .email-button a {
      background: #d69e2e;
    }
    .announcement-template .email-header {
      background: linear-gradient(135deg, #9f7aea 0%, #7b5df8 100%);
    }
    .announcement-template .email-content {
      background: #f5f3ff;
      padding: 20px;
      border-radius: 8px;
      box-shadow: inset 0 0 10px rgba(139, 92, 246, 0.1);
    }
    .announcement-template .email-content h3 {
      color: #7b5df8;
    }
    .announcement-template .email-button a {
      background: #9f7aea;
    }
  `;

  // تمپلیت‌های آماده
  const emailTemplates = {
    default: {
      name: 'پیش‌فرض',
      subject: 'پیام جدید از طرف ما',
      content: `
        <p>سلام USER_NAME عزیز،</p>
        <p>این یک پیام نمونه است که می‌توانید محتوای دلخواه خود را جایگزین کنید.</p>
        <p>ما همیشه آماده پاسخگویی به سوالات شما هستیم!</p>
      `,
      class: '',
      buttonText: 'مشاهده جزئیات',
      buttonLink: 'https://app.aryadiet.com/'
    },
    birthday: {
      name: 'تبریک تولد',
      subject: '🎉 تبریک ویژه تولد شما!',
      content: `
        <p>عزیز USER_NAME گرامی،</p>
        <p>تولدتان مبارک! 🎂 امیدواریم سال جدید زندگی‌تان پر از شادی، سلامتی و موفقیت باشد.</p>
        <p>به عنوان هدیه ویژه، یک کد تخفیف ۲۰٪ برای شما آماده کرده‌ایم:</p>
        <p style="font-size: 18px; font-weight: bold; text-align: center; color: #ff6b6b; margin: 20px 0;">BIRTHDAY2025</p>
        <p>این کد تا پایان هفته معتبر است. همین حالا از آن استفاده کنید!</p>
      `,
      class: 'birthday-template',
      buttonText: 'دریافت هدیه',
      buttonLink: 'https://app.aryadiet.com/'
    },
    welcome: {
      name: 'خوش‌آمدگویی',
      subject: 'به جمع ما خوش آمدید! 🌟',
      content: `
        <p>سلام USER_NAME عزیز،</p>
        <p>از اینکه به جمع ما پیوستید بسیار خوشحالیم!</p>
        <p>برای شروع، می‌توانید از منابع رایگان ما استفاده کنید:</p>
        <p>تیم پشتیبانی ما همیشه در کنار شماست.</p>
      `,
      class: 'welcome-template',
      buttonText: 'شروع رژیم غذایی',
      buttonLink: 'https://app.aryadiet.com/'
    },
    discount: {
      name: 'تخفیف ویژه',
      subject: 'فرصت استثنایی برای شما! 🔥',
      content: `
        <p>USER_NAME گرامی،</p>
        <p>یک فرصت ویژه برای شما آماده کرده‌ایم:</p>
        <div style="background: #fefcbf; border-left: 4px solid #d69e2e; padding: 15px; margin: 20px 0; border-radius: 8px;">
          <h3 style="margin-top: 0;">تخفیف ۳۰٪ برای تمام دوره‌ها</h3>
          <p>این تخفیف فقط تا پایان هفته معتبر است!</p>
          <p style="text-align: center; font-size: 20px; font-weight: bold;">DISCOUNT30</p>
        </div>
        <p>همین حالا از این فرصت استفاده کنید!</p>
      `,
      class: 'discount-template',
      buttonText: 'استفاده از تخفیف',
      buttonLink: 'https://app.aryadiet.com/'
    },
    announcement: {
      name: 'اطلاعیه مهم',
      subject: 'خبر مهم برای شما! 📢',
      content: `
        <p>سلام USER_NAME عزیز،</p>
        <p>یک اطلاعیه مهم برای شما داریم:</p>
        <div style="background: #f5f3ff; border-left: 4px solid #9f7aea; padding: 15px; margin: 20px 0; border-radius: 8px;">
          <h3 style="margin-top: 0;">به‌روزرسانی سیستم</h3>
          <p>در تاریخ ۱۵ مرداد ۱۴۰۴، سیستم ما به‌روزرسانی خواهد شد.</p>
          <p>لطفاً از اطلاعات خود نسخه پشتیبان تهیه کنید.</p>
        </div>
        <p>ممنون از همراهی شما!</p>
      `,
      class: 'announcement-template',
      buttonText: 'اطلاعات بیشتر',
      buttonLink: 'https://app.aryadiet.com/'
    }
  };

  // انتخاب تمپلیت
  const selectTemplate = (templateKey) => {
    const template = emailTemplates[templateKey];
    setSelectedTemplate(templateKey);
    setEmailSubject(template.subject);
    // حفظ USER_NAME در ادیتور
    setCustomContent(template.content);
    updateEmailContent(template.content, template.class, template.buttonText, template.buttonLink);
  };

   

  // به‌روزرسانی محتوای ایمیل
  const updateEmailContent = (content, templateClass = '', buttonText = 'مشاهده جزئیات', buttonLink = 'https://app.aryadiet.com/') => {
    // بررسی نوع کاربر برای تنظیم لینک
    const isConsultant = selectedUser ? selectedUser.userType === 'مشاوره' : filters.userType === 'مشاوره';
    const finalButtonLink = isConsultant ? 'https://appointment.aryadiet.com/' : buttonLink;

    // جایگزینی USER_NAME برای پیش‌نمایش
    const updatedContent = content.replace(/USER_NAME/g, selectedUser ? selectedUser.name : '[نام کاربر]');

    // تعریف استایل‌های inline برای تم‌های مختلف
    let headerBgColor = '#4a90e2';
    let contentBgColor = '#f8fafc';
    let buttonBgColor = '#4a90e2';
    let contentBorder = '';
    let contentPadding = '30px';

    if (templateClass === 'birthday-template') {
      headerBgColor = '#ff6b6b';
      contentBgColor = '#fff5f5';
      buttonBgColor = '#ff6b6b';
      contentBorder = '2px dashed #feb2b2';
      contentPadding = '20px';
    } else if (templateClass === 'welcome-template') {
      headerBgColor = '#48bb78';
      contentBgColor = '#f0fff4';
      buttonBgColor = '#48bb78';
      contentPadding = '20px';
    } else if (templateClass === 'discount-template') {
      headerBgColor = '#ecc94b';
      contentBgColor = '#fefcbf';
      buttonBgColor = '#d69e2e';
      contentBorder = 'border-left: 4px solid #d69e2e';
      contentPadding = '20px';
    } else if (templateClass === 'announcement-template') {
      headerBgColor = '#9f7aea';
      contentBgColor = '#f5f3ff';
      buttonBgColor = '#9f7aea';
      contentPadding = '20px';
    }

    const template = `
      <div style="font-family: Arial, sans-serif; max-width: 650px; margin: 30px auto; background: #ffffff; border: 1px solid #e2e8f0; direction: rtl; text-align: right;">
        <div style="padding: 30px; background: ${headerBgColor}; color: #ffffff; text-align: center;">
          <h1 style="margin: 0; font-size: 28px;">سلام ${selectedUser ? selectedUser.name : '[نام کاربر]'} عزیز</h1>
         
        </div>
        <div style="padding: 30px; background: #f8fafc;">
          <div style="font-size: 16px; line-height: 1.8; color: #2d3748; background: ${contentBgColor}; padding: ${contentPadding}; border-radius: 8px; ${contentBorder}">
            ${updatedContent}
          </div>
          <div style="margin: 25px 0; text-align: center;">
            <a href="${finalButtonLink}" style="display: inline-block; padding: 12px 30px; color: #ffffff; background: ${buttonBgColor}; text-decoration: none; border-radius: 25px; font-size: 16px;">${buttonText}</a>
          </div>
          <p style="font-size: 14px; color: #718096;">
            در صورت وجود هرگونه سوال، با <a href="mailto:admin@yourdomain.com" style="color: #4a90e2; text-decoration: none;">پشتیبانی</a> تماس بگیرید.
          </p>
        </div>
        <div style="background: #edf2f7; padding: 20px; text-align: center; font-size: 14px; color: #718096;">
          <p style="margin: 0;">© ${new Date().getFullYear()} رژیم غذایی آریایی. تمام حقوق محفوظ است.</p>
          <p style="margin: 5px 0 0;">
            <a href="#" style="color: #4a90e2; text-decoration: none;">حریم خصوصی</a> | 
            <a href="#" style="color: #4a90e2; text-decoration: none;">قوانین</a>
          </p>
        </div>
      </div>
      <!-- استایل‌های CSS برای پیش‌نمایش در مودال -->
      <style>${emailStyles}</style>
    `;
    setEmailContent(template);
  };

  // ارسال ایمیل


const handleSendEmail = () => {
  const recipients = selectedUser
    ? `به ${selectedUser.name} (${selectedUser.email})`
    : `به ${filteredUsers.length} کاربر`;

  Swal.fire({
    title: 'ارسال ایمیل',
    html: `آیا مطمئن هستید می‌خواهید این ایمیل را ${recipients} ارسال کنید؟`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'بله, ارسال کن',
    cancelButtonText: 'لغو',
  }).then((result) => {
    if (result.isConfirmed) {
      if (selectedUser) {
        // ارسال تکی
        const formData = new FormData();
        formData.append('subject', emailSubject);
        formData.append('content', emailContent);
        formData.append('email', selectedUser.email);

        axios.post(serverUrl + 'send-email', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then((response) => {
            toast.success(`ایمیل با موفقیت ارسال شد به ${selectedUser.name}`);
            setModalOpen(false);
            setEmailContent('');
            setEmailSubject('');
            setCustomContent('');
            setSelectedUser(null);
            setSelectedTemplate('default');
          })
          .catch((error) => {
            toast.error('خطا در ارسال ایمیل');
            console.error('Error sending email:', error);
          });
      } else {
        // ارسال گروهی
        filteredUsers.forEach((user) => {
          const userContent = customContent.replace(/USER_NAME/g, user.name || 'کاربر گرامی'); // جایگزینی USER_NAME با نام کاربر
          const template = emailTemplates[selectedTemplate];
          const finalContent = `
            <div style="font-family: Arial, sans-serif; max-width: 650px; margin: 30px auto; background: #ffffff; border: 1px solid #e2e8f0; direction: rtl; text-align: right;">
              <div style="padding: 30px; background: ${template.class === 'birthday-template' ? '#ff6b6b' : template.class === 'welcome-template' ? '#48bb78' : template.class === 'discount-template' ? '#ecc94b' : template.class === 'announcement-template' ? '#9f7aea' : '#4a90e2'}; color: #ffffff; text-align: center;">
                <h1 style="margin: 0; font-size: 28px;">سلام ${user.name || 'کاربر گرامی'} عزیز</h1>
              </div>
              <div style="padding: 30px; background: #f8fafc;">
                <div style="font-size: 16px; line-height: 1.8; color: #2d3748; background: ${template.class === 'birthday-template' ? '#fff5f5' : template.class === 'welcome-template' ? '#f0fff4' : template.class === 'discount-template' ? '#fefcbf' : template.class === 'announcement-template' ? '#f5f3ff' : '#f8fafc'}; padding: ${template.class ? '20px' : '30px'}; border-radius: 8px; ${template.class === 'birthday-template' ? 'border: 2px dashed #feb2b2' : template.class === 'discount-template' ? 'border-left: 4px solid #d69e2e' : ''}">
                  ${userContent}
                </div>
                <div style="margin: 25px 0; text-align: center;">
                  <a href="${filters.userType === 'مشاوره' ? 'https://appointment.aryadiet.com/' : template.buttonLink}" style="display: inline-block; padding: 12px 30px; color: #ffffff; background: ${template.class === 'birthday-template' ? '#ff6b6b' : template.class === 'welcome-template' ? '#48bb78' : template.class === 'discount-template' ? '#d69e2e' : template.class === 'announcement-template' ? '#9f7aea' : '#4a90e2'}; text-decoration: none; border-radius: 25px; font-size: 16px;">${template.buttonText}</a>
                </div>
                <p style="font-size: 14px; color: #718096;">
                  در صورت وجود هرگونه سوال، با <a href="mailto:admin@yourdomain.com" style="color: #4a90e2; text-decoration: none;">پشتیبانی</a> تماس بگیرید.
                </p>
              </div>
              <div style="background: #edf2f7; padding: 20px; text-align: center; font-size: 14px; color: #718096;">
                <p style="margin: 0;">© ${new Date().getFullYear()} رژیم غذایی آریایی. تمام حقوق محفوظ است.</p>
                <p style="margin: 5px 0 0;">
                  <a href="#" style="color: #4a90e2; text-decoration: none;">حریم خصوصی</a> | 
                  <a href="#" style="color: #4a90e2; text-decoration: none;">قوانین</a>
                </p>
              </div>
            </div>
            <!-- استایل‌های CSS برای پیش‌نمایش در مودال -->
            <style>${emailStyles}</style>
          `;
          const formData = new FormData();
          formData.append('subject', emailSubject);
          formData.append('content', finalContent);
          formData.append('email', user.email);

          axios.post(serverUrl + 'send-email', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
            .then((response) => {
              toast.success(`ایمیل با موفقیت ارسال شد به ${user.name}`);
            })
            .catch((error) => {
              toast.error(`خطا در ارسال ایمیل به ${user.name}`);
              console.error('Error sending email:', error);
            });
        });
        setModalOpen(false);
        setEmailContent('');
        setEmailSubject('');
        setCustomContent('');
        setSelectedUser(null);
        setSelectedTemplate('default');
      }
    }
  });
};

  // فیلترهای ویژه
  const specialFilters = [
    { value: '', label: 'همه کاربران' },
    { value: 'diet-user', label: 'کاربر رژیم' },
    { value: 'consultation-user', label: 'کاربر مشاوره' }
  ];

  // گزینه‌های فیلترهای جدید (می‌توان بر اساس نیاز گسترش داد)
  const userTypeOptions = [
    { value: '', label: 'همه' },
    { value: 'مشاوره', label: 'مشاوره' },
    { value: 'رژیم', label: 'رژیم' }
  ];

  const dietTypeOptions = [
    { value: '', label: 'همه' },
    { value: 'کاهش', label: 'کاهش' },
    { value: 'افزایش', label: 'افزایش' },
    { value: 'ثبات', label: 'ثبات' }
  ];

  const weightStabilityOptions = [
    { value: '', label: 'همه' },
    { value: 'stable', label: 'ثابت (نوسان کم)' }
  ];

  const bmiOptions = [
    { value: '', label: 'همه' },
    { value: 'custom', label: 'رنج دستی' }, // گزینه جدید برای رنج دستی
    { value: 'A', label: 'کمتر از ۱۵.۹۹ (A)' },
    { value: 'B', label: '۱۶ تا ۱۶.۹۹ (B)' },
    { value: 'C', label: '۱۷ تا ۱۸.۴۹۹ (C)' },
    { value: 'D', label: '۱۸.۵ تا ۲۴.۹۹ (D)' },
    { value: 'E', label: '۲۵ تا ۲۹.۹۹ (E)' },
    { value: 'F', label: '۳۰ تا ۳۴.۹۹ (F)' },
    { value: 'G', label: '۳۵ تا ۳۹.۹۹ (G)' },
    { value: 'H', label: 'بیشتر از ۴۰ (H)' }
  ];

  const genderOptions = [
    { value: '', label: 'همه' },
    { value: 'مرد', label: 'مرد' },
    { value: 'زن', label: 'زن' }
  ];

  const ageOptions = [
    { value: '', label: 'همه' },
    { value: 'custom', label: 'رنج دستی' },
    { value: 'under18', label: 'کمتر از ۱۸' },
    { value: '18-30', label: '۱۸-۳۰' },
    { value: '30-50', label: '۳۰-۵۰' },
    { value: 'over50', label: 'بیشتر از ۵۰' }
  ];

  // نمایش وضعیت لودینگ و خطا
  if (loading) {
    return <div>در حال دریافت اطلاعات...</div>;
  }

  if (error) {
    return <div>خطا در دریافت اطلاعات: {error}</div>;
  }

  return (
    <>
      <ToastContainer />
      <div className="content" style={{ direction: "rtl", textAlign: "right" }}>
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">ارسال ایمیل</CardTitle>
              </CardHeader>
              <CardBody>
                {/* بخش فیلترها */}
                <Card style={{ marginBottom: '20px' }}>
                  <CardBody>
                    <Form>
                      <Row>
                        <Col md="4">
                          <FormGroup>
                            <Label for="specialFilter">فیلتر ویژه</Label>
                            <Input
                              type="select"
                              id="specialFilter"
                              value={filters.specialFilter}
                              onChange={(e) => setFilters({...filters, specialFilter: e.target.value})}
                            >
                              {specialFilters.map(filter => (
                                <option key={filter.value} value={filter.value}>{filter.label}</option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup>
                            <Label for="search">جستجو</Label>
                            <Input
                              type="text"
                              id="search"
                              placeholder="جستجو نام یا ایمیل..."
                              value={filters.search}
                              onChange={(e) => setFilters({...filters, search: e.target.value})}
                              style={{ color: '#2d3748' }}
                            />
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup>
                            <Label for="userType">نوع کاربر</Label>
                            <Input
                              type="select"
                              id="userType"
                              value={filters.userType}
                              onChange={(e) => setFilters({...filters, userType: e.target.value})}
                            >
                              {userTypeOptions.map(option => (
                                <option key={option.value} value={option.value}>{option.label}</option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="4">
                          <FormGroup>
                            <Label for="dietType">نوع رژیم</Label>
                            <Input
                              type="select"
                              id="dietType"
                              value={filters.dietType}
                              onChange={(e) => setFilters({...filters, dietType: e.target.value})}
                            >
                              {dietTypeOptions.map(option => (
                                <option key={option.value} value={option.value}>{option.label}</option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup>
                            <Label for="expiredDuration">مدت زمان پایان دوره (روز)</Label>
                            <Input
                              type="number"
                              id="expiredDuration"
                              placeholder="حداقل روز گذشته (مثلا 30)"
                              value={filters.expiredDuration}
                              onChange={(e) => setFilters({...filters, expiredDuration: e.target.value})}
                            />
                          </FormGroup>
                        </Col>
                        <Col md="4">
    <FormGroup>
      <Label for="purchaseCount">تعداد دوره‌های خریداری شده</Label>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <Input
          type="number"
          id="purchaseCount"
          placeholder="(مثلا 1)"
          value={filters.purchaseCount}
          onChange={(e) => setFilters({...filters, purchaseCount: e.target.value})}
          style={{ width: '60%' }}
        />
        <div style={{ display: 'flex', gap: '5px' }}>
          {purchaseCountFilterTypeOptions.map(option => (
            <FormGroup check inline key={option.value}>
              <Label check style={{ fontSize: '0.9rem', margin: '0' }}>
                <Input
                  type="radio"
                  name="purchaseCountFilterType"
                  value={option.value}
                  checked={purchaseCountFilterType === option.value}
                  onChange={(e) => setPurchaseCountFilterType(e.target.value)}
                />
                {option.label}
              </Label>
            </FormGroup>
          ))}
        </div>
      </div>
    </FormGroup>
  </Col>
                      </Row>
                      <Row>
                        <Col md="4">
                          <FormGroup>
                            <Label for="weightLossPercent">درصد کاهش وزن (حداقل)</Label>
                            <Input
                              type="number"
                              id="weightLossPercent"
                              placeholder="حداقل درصد (مثلا 10)"
                              value={filters.weightLossPercent}
                              onChange={(e) => setFilters({...filters, weightLossPercent: e.target.value})}
                            />
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup>
                            <Label for="weightGainPercent">درصد افزایش وزن (حداقل)</Label>
                            <Input
                              type="number"
                              id="weightGainPercent"
                              placeholder="حداقل درصد (مثلا 10)"
                              value={filters.weightGainPercent}
                              onChange={(e) => setFilters({...filters, weightGainPercent: e.target.value})}
                            />
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup>
                            <Label for="weightStability">ثبات وزن</Label>
                            <Input
                              type="select"
                              id="weightStability"
                              value={filters.weightStability}
                              onChange={(e) => setFilters({...filters, weightStability: e.target.value})}
                            >
                              {weightStabilityOptions.map(option => (
                                <option key={option.value} value={option.value}>{option.label}</option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                      <Col md="4">
    <FormGroup>
      <Label for="bmi">BMI</Label>
      <Input
        type="select"
        id="bmi"
        value={filters.bmi}
        onChange={(e) => setFilters({...filters, bmi: e.target.value, bmiMin: '', bmiMax: ''})}
      >
        {bmiOptions.map(option => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </Input>
      {filters.bmi === 'custom' && (
        <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
          <Input
            type="number"
            placeholder="حداقل BMI (مثلا 14)"
            value={filters.bmiMin}
            onChange={(e) => setFilters({...filters, bmiMin: e.target.value})}
            style={{ width: '50%' }}
          />
          <Input
            type="number"
            placeholder="حداکثر BMI (مثلا 15)"
            value={filters.bmiMax}
            onChange={(e) => setFilters({...filters, bmiMax: e.target.value})}
            style={{ width: '50%' }}
          />
        </div>
      )}
    </FormGroup>
  </Col>
                        <Col md="4">
                          <FormGroup>
                            <Label for="gender">جنسیت</Label>
                            <Input
                              type="select"
                              id="gender"
                              value={filters.gender}
                              onChange={(e) => setFilters({...filters, gender: e.target.value})}
                            >
                              {genderOptions.map(option => (
                                <option key={option.value} value={option.value}>{option.label}</option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col md="4">
    <FormGroup>
      <Label for="age">سن</Label>
      <Input
        type="select"
        id="age"
        value={filters.age}
        onChange={(e) => setFilters({...filters, age: e.target.value, ageMin: '', ageMax: ''})}
      >
        {ageOptions.map(option => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </Input>
      {filters.age === 'custom' && (
        <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
          <Input
            type="number"
            placeholder="حداقل سن (مثلا 20)"
            value={filters.ageMin}
            onChange={(e) => setFilters({...filters, ageMin: e.target.value})}
            style={{ width: '50%' }}
          />
          <Input
            type="number"
            placeholder="حداکثر سن (مثلا 30)"
            value={filters.ageMax}
            onChange={(e) => setFilters({...filters, ageMax: e.target.value})}
            style={{ width: '50%' }}
          />
        </div>
      )}
    </FormGroup>
  </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>

                {/* دکمه ارسال گروهی */}
                {filteredUsers.length > 0 && (
                  <div style={{ marginBottom: '15px', textAlign: 'left' }}>
                    <Button 
                      color="primary" 
                      onClick={() => {
                        setSelectedUser(null);
                        selectTemplate('default');
                        setModalOpen(true);
                      }}
                    >
                      ارسال ایمیل گروهی ({filteredUsers.length} کاربر)
                    </Button>
                  </div>
                )}

                {/* جدول کاربران */}
                <Table responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>#</th>
                      <th>نام</th>
                      <th>ایمیل</th>
                      <th>تعداد دوره‌ها</th>
                      <th>عملیات</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredUsers.length > 0 ? (
                      filteredUsers.map((user, index) => (
                        <tr key={user.id}>
                          <td>{index + 1}</td>
                          <td>{user.name}</td>
                          <td>{user.email}</td>
                          <td>{user.NumberCoursespurchased}</td>
                          <td>
                            <Button
                              color="info"
                              size="sm"
                              onClick={() => {
                                setSelectedUser(user);
                                selectTemplate('default');
                                setModalOpen(true);
                              }}
                            >
                              ارسال ایمیل
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" style={{ textAlign: 'center' }}>کاربری یافت نشد</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* مودال ارسال ایمیل */}
        <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} size="lg">
          <ModalHeader toggle={() => setModalOpen(false)}>
            {selectedUser ? `ارسال ایمیل به ${selectedUser.name}` : 'ارسال ایمیل گروهی'}
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>موضوع ایمیل</Label>
              <Input
                type="text"
                value={emailSubject}
                onChange={(e) => setEmailSubject(e.target.value)}
                placeholder="موضوع ایمیل..."
                style={{ color: '#2d3748' }}
              />
            </FormGroup>
            
            <FormGroup>
              <Label>انتخاب تمپلیت</Label>
              <div style={{ marginBottom: '15px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                {Object.keys(emailTemplates).map(key => (
                  <Button 
                    key={key}
                    color={key === selectedTemplate ? 'primary' : 'secondary'}
                    outline={key !== selectedTemplate}
                    onClick={() => selectTemplate(key)}
                  >
                    {emailTemplates[key].name}
                  </Button>
                ))}
              </div>
            </FormGroup>
            
            <FormGroup>
              <Label>محتوای سفارشی ایمیل</Label>
              <ReactQuill
                theme="snow"
                value={customContent}
                onChange={(content) => {
                  setCustomContent(content);
                  updateEmailContent(content, emailTemplates[selectedTemplate].class, emailTemplates[selectedTemplate].buttonText, emailTemplates[selectedTemplate].buttonLink);
                }}
                style={{ height: '300px', marginBottom: '60px' }}
                modules={{
                  toolbar: [
                    [{ 'header': [1, 2, 3, false] }],
                    [{ 'font': [] }],
                    [{ 'size': ['small', false, 'large', 'huge'] }],
                    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    [{ 'align': [] }],
                    [{ 'color': [] }, { 'background': [] }],
                    ['link', 'image'],
                    ['code-block'],
                    ['clean']
                  ]
                }}
              />
            </FormGroup>
            
            <div 
              style={{ 
                border: '1px solid #e2e8f0', 
                padding: '20px', 
                marginTop: '20px',
                borderRadius: '8px',
                backgroundColor: '#f9fafb'
              }}
              className="preview-container"
            >
              <h5>پیش‌نمایش ایمیل:</h5>
              <div dangerouslySetInnerHTML={{ __html: emailContent }} />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => setModalOpen(false)}>
              لغو
            </Button>
            <Button color="primary" onClick={handleSendEmail}>
              ارسال ایمیل
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
}

export default Email;